import { JobInterviewResponse } from '@doda/api-client/aspida/@types';
import {
  Text,
  LightBulb,
  WorkStyle,
  Atmosphere,
  Superiority,
} from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/ReferredJobDetail/TextWithLF';
import classNames from 'classnames';
import { InterviewReportItem } from './InterviewReportItem';
import { SectionItemPosition } from '../../CheckMarkBalloon/SectionItemPosition';
import styles from './index.module.scss';

/**
 * InterviewReportのProps
 */
export interface Props {
  interview: JobInterviewResponse;
}

/**
 * 見出し
 */
const HEADING = {
  '1': {
    icon: <WorkStyle size="XS" />,
    text: '社員の働き方は？',
  },
  '2': {
    icon: <Atmosphere size="XS" />,
    text: '人や職場の雰囲気は？',
  },
  '3': {
    icon: <Superiority size="XS" />,
    text: '会社・事業の優位性は？',
  },
  '4': {
    icon: <LightBulb size="XS" color="blue" />,
    text: '商品・サービスの強みは？',
  },
} as const;

/**
 * 取材レポート
 */
export const InterviewReport: React.FC<Props> = ({ interview }: Props) => {
  return (
    <>
      <SectionItemPosition />
      <div className={styles['jobSearchDetail-interviewReport']}>
        <div
          className={classNames(
            styles['jobSearchDetail-interviewReport__backGroundImage'],
            styles['jobSearchDetail-interviewReport__title']
          )}
        >
          <div
            className={styles['jobSearchDetail-interviewReport__titleContent']}
          >
            <Text color="white" size="20" weight="bold">
              取材レポート
            </Text>
          </div>
        </div>
        <div className={styles['jobSearchDetail-interviewReport__contents']}>
          <div>
            <div
              className={
                styles['jobSearchDetail-interviewReport__contentsTitle']
              }
            >
              {HEADING[interview?.reportKind || '1'].icon}
              <Text color="blue" size="12" weight="bold">
                {HEADING[interview?.reportKind || '1'].text}
              </Text>
            </div>
            <Text color="black_pc" size="20" weight="bold">
              {interview.reportTitle}
            </Text>
          </div>
          <div
            className={
              styles['jobSearchDetail-interviewReport__contentsExplanation']
            }
          >
            <Text color="black_pc" size="14--articlePC">
              <TextWithLF text={interview.reportBody || ''} />
            </Text>
            <figure
              className={
                styles[
                  'jobSearchDetail-interviewReport__contentsExplanationImageWrap'
                ]
              }
            >
              <img
                src={interview.reportImage}
                alt=""
                className={
                  styles[
                    'jobSearchDetail-interviewReport__contentsExplanationImage'
                  ]
                }
              />
              <Text color="gray" size="11" as="figcaption">
                {interview.reportImageCaption}
              </Text>
            </figure>
          </div>
          <div
            className={
              styles['jobSearchDetail-interviewReport__contentsInterview']
            }
          >
            <InterviewReportItem reportRewarding={interview.reportRewarding} />
            <InterviewReportItem reportDifficult={interview.reportDifficult} />
          </div>
        </div>
      </div>
    </>
  );
};
